<template>
  <div>
    <h1 class="mb-4 font-bold text-3xl">
      Bank
    </h1>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <search-filter
        v-model="form.search"
        class="w-full max-w-md mr-4"
        @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select
          v-model="form.trashed"
          class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">
            With Trashed
          </option>
          <option value="only">
            Only Trashed
          </option>
        </select>
      </search-filter>
      <inertia-link
        class="btn-indigo"
        :href="route('bank.create')">
        <span>Create</span>
        <span class="hidden md:inline">Bank</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">
            Nama Bank
          </th>
          <th class="px-6 pt-6 pb-4">
            Deskripsi
          </th>
          <th class="px-6 pt-6 pb-4" colspan="2">
            Last Update
          </th>
        </tr>
        <tr
          v-for="bank in banks.data"
          :key="bank.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('bank.edit', bank.id)">
              {{ bank.name }}
              <icon
                v-if="bank.deleted_at"
                name="trash"
                class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('bank.edit', bank.id)"
              tabindex="-1">
              {{ bank.descriptions }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('bank.edit', bank.id)"
              tabindex="-1">
              {{ bank.updated_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link
              class="px-4 flex items-center"
              :href="route('bank.edit', bank.id)"
              tabindex="-1">
              <icon
                name="cheveron-right"
                class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="banks.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">
            No bank found.
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="banks.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { router, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Bank' },
    components: {
        Icon,
        Pagination,
        SearchFilter,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        filters: Object,
        banks: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                router.get('bank', pickBy(this.form), {
                    preserveState: true,
                })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
